/**
 * Agent Asset Service
 * AIDLC Administrative Backend
 *
 * API calls for agent assets (scan results, reports, outputs).
 */

import apiClient from './api';
import type { AgentAsset } from '../types/agentAsset';

export async function getAgentAssets(agentId: string, action?: string): Promise<AgentAsset[]> {
  const params: Record<string, string> = {};
  if (action) params.action = action;
  const response = await apiClient.get<AgentAsset[]>(`/agents/${agentId}/assets`, { params });
  return response.data;
}

export async function getAgentAsset(agentId: string, assetId: string): Promise<AgentAsset> {
  const assets = await getAgentAssets(agentId);
  const asset = assets.find(a => a.id === assetId);
  if (!asset) throw new Error(`Asset ${assetId} not found`);
  return asset;
}

export async function createAgentAsset(agentId: string, data: {
  templateId?: string;
  templateStepAction: string;
  title: string;
  summary?: string;
  result?: string;
  findings?: Array<{ severity: string; title: string; description: string }>;
  projectId?: string;
  metadata?: Record<string, unknown>;
}): Promise<AgentAsset> {
  const response = await apiClient.post<AgentAsset>(`/agents/${agentId}/assets`, data);
  return response.data;
}

export async function getAgentInbox(agentId: string, status?: string): Promise<import('../types/chat').PromptQueueItem[]> {
  const params: Record<string, string> = {};
  if (status) params.status = status;
  const response = await apiClient.get(`/agents/${agentId}/inbox`, { params });
  return response.data;
}
